import { isBrowser } from '../index'
import { DuplicateError, NotInBrowserError } from '../errors'
import { hashName } from '../strings/hashString'
import Logger from 'services/Logger'

export const loadScript = (source: string, strategy: 'async' | 'defer' | 'none' = 'async', id?: string) => {
	return new Promise<void>((resolve, reject) => {
		const hash = id || hashName('script', source)
		if (isBrowser()) {
			if (document.getElementById(hash) === null) {
				const helper = document.createElement('script')
				helper.id = hash
				helper.src = source
				switch (strategy) {
					case 'async':
						helper.async = true
						break
					case 'defer':
						helper.setAttribute('importance', 'lowest')
						helper.defer = true
						break
					case 'none':
						break
				}
				helper.onload = () => {
					resolve()
				}
				helper.onerror = (event, source, line, col, error) => reject(error || event)
				document.head.appendChild(helper)
				if (document.getElementById(hash) === null) {
					console.log('script not found')
				} else {
				}
			} else {
				Logger.debug('duplicate tag')
				reject(new DuplicateError(source))
			}
		} else {
			reject(new NotInBrowserError())
		}
	})
}
